import React, { Component } from 'react';
import {
    Button, Table, notification, message, Popconfirm,
} from 'antd';
import {
    getHonorManageList,
    addHonorRecord,
    updateHonorRecord,
    deleteHonorRecord
} from "../../../modules/player/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {injectIntl} from "react-intl-context";
import AddHonorModal from "./AddHonorModal";



class HonorManageModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageNo: 1,
            pageSize: 10,
            showAdd:false,
            selectValue:null,
            addFlag:false,
        };
    }
    componentDidMount() {
        const {pageNo, pageSize, selectValue} = this.state;
        let {getHonorManageList,userId} = this.props;
        getHonorManageList(userId,pageNo, pageSize);

    }

    onSubmitEvent = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let { onSubmitEvent } = this.props;
                onSubmitEvent && onSubmitEvent(values);
            }
        });
    }

    //分页事件
    onPageChangeEvent = (current, pageSize) => {
        let {getHonorManageList,userId} = this.props;
        this.setState({
            pageNo: current,
            pageSize: pageSize,
        });
        getHonorManageList(userId,current, pageSize);
    }

    onShowBind =()=>{
        this.setState({
            showAdd:true,
            addFlag:true,
            selectValue:null
        })

    }

    onUpdate =(value)=>{
        this.setState({
            showAdd:true,
            selectValue:value,
            addFlag:false
        })

    }

    renderTitle=()=>{
        return(
            <Button style={{marginBottom:16}} onClick={this.onShowBind}>添加荣誉</Button>
        )
    }
    handleCancel = e => {
        this.setState({
            showAdd: false,
        });
    };

    // 增加赛事信息
    onAddSaiEvent = async (awardDate,name,grade) => {
        const {addHonorRecord,userId,getHonorManageList, updateHonorRecord} = this.props;
        const {showAdd, selectValue} = this.state;
        if(selectValue==null){
            await addHonorRecord(userId,awardDate,name,grade);
            message.success('添加荣誉纪录成功');
        }else{
            await updateHonorRecord(selectValue.id,awardDate,name,grade);
            message.success('修改荣誉纪录成功');
        }
        await getHonorManageList(userId,1,10);
        this.setState({showAdd: !showAdd,pageNo:1, selectValue: null});
    }

    //删除赛事信息的方法
    onDeleteEvent = async (id) => {
        const { deleteHonorRecord, getHonorManageList,userId } = this.props;
        const { page, size } = this.state;
        try {
            await deleteHonorRecord(id);
            notification.success({ message: '删除成功' });
            getHonorManageList(userId,page, size);
        } catch (e) {
            console.log(e);
        }
    }

    render() {
        const {
            honorList, loading
        } = this.props;
        const {pageSize,pageNo,showAdd, selectValue,addFlag} = this.state;

        return (
            <div>
                <Table

                    columns={
                        [
                            {
                                title: '比赛时间',
                                dataIndex: 'awardDate',
                                key: 'awardDate',
                                align: 'center',
                            },
                            {
                                title: '赛事名称',
                                dataIndex: 'name',
                                key: 'name',
                                align: 'center',
                            },
                            {
                                title: '获奖名次',
                                dataIndex: 'grade',
                                key: 'grade',
                                align: 'center',
                            },
                            {
                                title: '操作',
                                dataIndex: '' +
                                    'operate',
                                key: 'operate',
                                align: 'center',
                                render: (row, text) => (
                                    <div>
                                        <Button type="primary" style={{
                                            marginRight:10,
                                            marginBottom:10
                                        }}  onClick={()=>this.onUpdate(text)} >修改</Button>
                                        <Popconfirm title={`确定要删除这个赛事记录吗?`}
                                                    onConfirm={() => this.onDeleteEvent(text.id)}
                                                    okText="确认" onCancel={this.onEvent} cancelText="取消" style={{ backgroundColor: '#ff0000', color: '#fff'}}>
                                            <Button type="danger" >删除</Button>
                                        </Popconfirm>
                                    </div>
                                ),
                            },
                        ]
                    }
                    title={
                        this.renderTitle
                    }
                    dataSource={honorList.data ? honorList.data : []}
                    bordered
                    loading={loading}
                    pagination={{
                        total: honorList ? honorList.total : 0,
                        current: pageNo,
                        pageSize: pageSize,
                        onChange: this.onPageChangeEvent,
                        showTotal:(total)=>{
                            return `总计 ${total}条数据`;
                        }
                    }}
                />

                <AddHonorModal 
                    addFlag={addFlag}
                    values={selectValue} 
                    visible={showAdd}
                    onSubmitEvent={this.onAddSaiEvent}
                    onCancel={this.handleCancel}
                />
            </div>

        );
    }
}

const mapStateToProps = (state => {
        console.log('mapStateToPropsstate',state);
        return {
            ...state.ProfessionalPlayer
        }
    }
);

const mapDispatchToProps = {
    getHonorManageList,
    addHonorRecord,
    updateHonorRecord,
    deleteHonorRecord
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(HonorManageModal)));
